import type { DataTableSurface } from '@gto/ui/data-table'

/**
 * The elevation the table body paints, and the matching Tailwind class.
 *
 * ONE source because two places must agree: the wrapper passes the surface to the DS, and any row
 * the app pins with `position: sticky` has to paint an OPAQUE background of its own (the rows it
 * scrolls over would otherwise show through) — in exactly this shade. They drifted once already:
 * the pinned totals row hardcoded `elevation2` to match the card, then the body moved to
 * `elevation3` and the row started reading as a different elevation.
 *
 * The DS has the same map internally (`SURFACE_BG`, "ONE source for every element that must match a
 * table surface") but does not export it; if it ever lands on the `@gto/ui/data-table` barrel, drop
 * this in favour of it.
 */
export const TABLE_SURFACE: DataTableSurface = 'elevation3'

/** Literal, not interpolated — Tailwind only compiles classes it can see whole. */
export const TABLE_SURFACE_BG = 'bg-paper-elevation3'
